import { push } from 'react-router-redux';
import Cookies from 'js-cookie';


////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// SET INITIAL PASSWORD
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestSetPassword = packet => {
  return {
    type: 'REQUEST_SET_PASSWORD',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveSetPasswordSuccess = data => ({
  type: 'RECEIVE_SET_PASSWORD_SUCCESS',
  data
})

export const receiveSetPasswordFail = data => ({
  type: 'RECEIVE_SET_PASSWORD_FAIL',
  data
})

export const tryToSetPassword = packet => (dispatch, getState) => {

  dispatch(requestSetPassword(packet));

  let headers = {
    "Content-Type": "application/json",
  }

  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/users/set-password', {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveSetPasswordSuccess(json.data));
      dispatch(push('/sign-in'));
    })
    .catch(e => {
      dispatch(receiveSetPasswordFail({errors:e, lastSubmit: packet}));
    })
}
